import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_LIST_FOR_DISCOUNT_QUERY = graphql(/* GraphQL */ `
	query DiscountListForDiscount($hotelID: ID!) {
		discountList(hotelID: $hotelID) {
			hotelID
			ordinary {
				id
				name
				hotelID
				discountID
				discountCode
				staticTargetType
				staticTermType
				inSale
				discountType
				ratio
				discountPriceTotal {
					currencyType
					amount
				}
				discountPriceTotalLimit {
					currencyType
					amount
				}
				static {
					currencyType
					amount
				}
			}
			longTerm {
				id
				name
				hotelID
				discountID
				discountCode
				inSale
				discountPriceTotal {
					currencyType
					amount
				}
				longTermStayDiscountObject {
					includeSmallestNights
					discountType
					ratio
					staticTargetType
					static {
						currencyType
						amount
					}
				}
				discountPriceTotalLimit {
					currencyType
					amount
				}
			}
			multi {
				id
				name
				hotelID
				discountID
				discountCode
				inSale
				multiDiscounts
				discountPriceTotal {
					currencyType
					amount
				}
				discountPriceTotalLimit {
					currencyType
					amount
				}
			}
		}
	}
`);
